import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["onSelectCurrency", "selectedCurrency", "useQuery"];
var __jsx = React.createElement;
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import React from "react";
import { css } from "@emotion/core";
import { Dropdown } from "@zapier/design-system";
import { sortCurrenciesByArray } from "@zapier/checkout/esm/utils";
import { emitPlanChangeInteractionEvent } from "@zapier/checkout/esm/utils/tracking";
import { defaultCurrency, useCurrencies } from "@zapier/currency";
import { FlagIcon } from "./FlagIcon";
import { currencyOrder } from "./constants";

// Rebrand styles
import { jsx as ___EmotionJSX } from "@emotion/core";
const containerCss = process.env.NODE_ENV === "production" ? {
  name: "1oibcei-containerCss",
  styles: "width:160px;text-align:left;@media (max-width:375px){width:100%;}};label:containerCss;"
} : {
  name: "1oibcei-containerCss",
  styles: "width:160px;text-align:left;@media (max-width:375px){width:100%;}};label:containerCss;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
/**
 * A dropdown that allows the user to select a currency to pay in.
 */
export const CurrencyDropdown = _ref => {
  let {
      onSelectCurrency,
      selectedCurrency = defaultCurrency,
      useQuery
    } = _ref,
    restProps = _objectWithoutProperties(_ref, _excluded);
  const {
    isLoading,
    currencies: options,
    error
  } = useCurrencies({
    useQuery
  });
  const onChangeCurrency = currency => {
    onSelectCurrency(currency);
    emitPlanChangeInteractionEvent({
      event_action: "select_currency",
      interaction_goal: "select currency",
      interaction_name: "currency dropdown",
      option_selected: currency.name
    });
  };

  // Don't show if loading or error
  if (isLoading || error) {
    return null;
  }
  return ___EmotionJSX("div", _extends({
    css: containerCss
  }, restProps), ___EmotionJSX(Dropdown, _extends({
    ariaLabel: "Currency",
    getLabelForItem: item => `${item.name} ${item.symbol}`,
    items: [...options].sort((a, b) => sortCurrenciesByArray(a, b, currencyOrder)),
    menuAriaLabel: "List of currencies",
    onChange: currency => onChangeCurrency(currency),
    placeholder: "Choose a currency...",
    renderIcon: item => {
      //@ts-ignore
      return !!item && ___EmotionJSX(FlagIcon, {
        name: item.icon
      });
    }
    // Pull this custom code up from the checkout's Dropdown component
  }, selectedCurrency ? {
    selectedItem: selectedCurrency
  } : {
    initialSelectedItem: selectedCurrency
  })));
};
//# sourceMappingURL=CurrencyDropdown.js.map
// @zapier/checkout@7.9.7 (23abc9ace)
